import React from 'react'
import './styles.scss'
import { useTranslation } from 'react-i18next'

const Footer = () => {
  const { t } = useTranslation()

  return (
    <footer className="mygiata_footer">
      <div className="mygiata_footer_top">
        <nav className="mygiata_footer_navi">
          <ul>
            <li><a href={t('URL_LEGAL_NOTICE')} rel="noreferrer" target="_blank">{t('LEGAL_NOTICE')}</a></li>
            <li><a href={t('URL_PRIVACY_POLICY')} rel="noreferrer" target="_blank">{t('PRIVACY_POLICY')}</a></li>
          </ul>
        </nav>
        <div className="mygiata_copyright">&copy; GIATA GmbH - {t('ALL_RIGHTS_RESERVED')}</div>
      </div>
    </footer>
  )
}

export default Footer
